import { Typography } from "@material-ui/core";
export function enoxaparinDoseText(renalImpairmentLevel, weight) {
    let text = [];
    text.push([<Typography gutterBottom variant="body1" style={{ marginTop: 20 }}>
                    <strong>
                    ENOXAPARIN <br /> TREATMENT DOSE IS
                    </strong>
                </Typography>,
                <Typography variant="h6" color="primary">
                    {Math.round((weight - 1) / 10) * 10} mg {renalImpairmentLevel == "severe" ? "ONCE" : "TWICE"} DAILY
                </Typography>
                ]);
    if (renalImpairmentLevel != 'severe') {
        text.push([<Typography variant="body2">
                        <p>Round weight to nearest 10kg when dosing and round down if interval of 5kg</p>
                    </Typography>]);
    }
    return text;
}